import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";
import QueueAssociation from "../association";
import QueueCell from "../cell";



const operationURLS = {
  create: "/extensionsSecondary/switchAcd/create",
  update: "/extensionsSecondary/switchAcd/update",
  list: "/extensionsSecondary/switchAcd/list",
 
};

const getColumns = (onDelete, onEdit) => {
  return [
    {
      Header: "ACD Number",
      accessor: "extension",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().required("Required"),
    },
    {
      Header: "Queue Name",
      accessor: "data",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "select",
      isUserGenerated: true,
      width: 6,
      options: {
        keyField: "systemName",
        keyDescription: "description",
        values: [],
        url: "queue/listAll/queue",
      },
      Cell: ({ row,value }) => <QueueCell row={row} value={value} />,
    },
    {
      Header: "Strategy",
      accessor: "strategy",
      displayInList: true,
      allowInForm: true,
      isUserGenerated: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().required("Required"),
      controlType: "select",
      width: 6,
      options: {
        keyField: "id",
        keyDescription: "description",
        values: [
          { id: "round-robin", description: "Round Robin" },
          {
            id: "ring-all",
            description: "Ring All",
          },
          { id: "top-down", description: "Top Down" },
          { id: "acd", description: "ACD" },
          { id: "console", description: "Console" },
        ],
      },
    },
    {
        Header: "Action",
        accessor: "id",
        displayInList: true,
        allowInForm: false,
        Cell: ({ row, value }) => (
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <QueueAssociation row={row} />
            <RowAction row={row} value={value} onDelete={onDelete} onEdit={onEdit} />
          </div>
        ),
      }
      
  ];
};

export { getColumns, operationURLS };